// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"27":"f1d597cf","238":"3233670d","386":"ab42189a","416":"bdbbd0e6","456":"3e0ba3b0","635":"560326ae"}[chunkId] + ".chunk.css";
};